import { Card } from '../../../card/Card'
import PreferencesForm from './preferenceComponents/PreferencesForm'

/** Language and theme of the app. */
const Preferences = () => (
  <Card className="col-12 responsive-half-card">
    <PreferencesForm />
  </Card>
)

export default Preferences
